import { gql } from 'apollo-angular';

const GET_ORGANIZATION_USERS = gql`
  query organization($id: Long!) {
    organization(id: $id) {
      id
      notifications {
        name
        displayName
        description
      }
      users {
        id
        firstName
        middleInitial
        lastName
        emailAddress
        jobTitle
        active
        lastActivityTime
        permissions
        mobilePhone
        fax
        subscriptions {
          name
          subscribed
        }
        assignedOrgs {
          allOrgsAssigned
          organizations {
            id
          }
        }
      }
    }
  }
`;

export default GET_ORGANIZATION_USERS;
